import Utils from 'tools/utils';
import classnames from 'classnames';
import { i18n } from 'core/localization';

export function getServiceState(serviceState, text, operatingState, agentStatus, qualifierError, assetMaintenance) {
	let tooltip = '';
	let exclamation, statusClass, exclamationClasses, clockIcon;
	if (typeof serviceState === 'string') {
		statusClass = Utils.getStateClass(serviceState);
	} else {
		statusClass = Utils.getStateClassFromIndex(serviceState);
	}
	let classArray = ['cw_service_indicator', 'js_service_state', 'cw_status'];
	if (operatingState === 'IN_MAINTENANCE') {
		classArray.push('is_idle', 'cw_indicator', 'glyphicons', 'wrench');
		tooltip = i18n('Service in maintenance');
	} else if (operatingState === 'NON_OPERATIONAL') {
		classArray.push('is_idle', 'cw_indicator');
		clockIcon = true;
		tooltip = i18n('Outside operating period');
	} else {
		classArray.push(statusClass);
		if (qualifierError || ['AGENT_DOWN', 'AGENT_MAINTENANCE'].indexOf(agentStatus) !== -1 || assetMaintenance) {
			tooltip = [];
			let exclamationClass;
			if (qualifierError) {
				exclamationClass = 'exclamation-mark';
				tooltip.push(i18n('Qualifier error'));
			}
			if (agentStatus === 'AGENT_DOWN') {
				exclamationClass = 'exclamation-mark';
				tooltip.push(i18n('Agent in warning'));
			} else if (agentStatus === 'AGENT_MAINTENANCE') {
				exclamationClass = 'wrench';
				tooltip.push(i18n('Agent in maintenance'));
			}
			if (assetMaintenance) {
				if (!qualifierError) {
					exclamationClass = 'wrench';
				}
				tooltip.push(i18n('Asset in maintenance'));
			}
			tooltip = tooltip.join(' / ');
			exclamationClasses = classnames('glyphicons', exclamationClass);
			exclamation = `<span class="${exclamationClasses}">`;
		}
	}

	let classes = classnames(classArray);
	let html = `<span class="${classes}" title="${tooltip}">`;
	if (exclamation) {
		html += exclamation;
	} else if (clockIcon) {
		html += Utils.renderClockCircle();
	}

	return $(html).prop('outerHTML') + (text || '');
}
